import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

const Popup = ({ trigger, content, flowing = false, hoverable = false }) => {
  const [isHovering, setIsHovering] = useState(false);
  const [popupStyle, setPopupStyle] = useState({});
  const [position, setPosition] = useState("bottom");
  const popupRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (isHovering && wrapperRef.current && popupRef.current) {
      const wrapperRect = wrapperRef.current.getBoundingClientRect();
      const popupWidth = 250;
      const popupHeight = 250;
      const gap = 8;

      const spaceBottom = window.innerHeight - wrapperRect.bottom;
      const spaceTop = wrapperRect.top;
      const spaceRight = window.innerWidth - wrapperRect.right;
      const spaceLeft = wrapperRect.left;

      let newPosition = "bottom";
      let styles = {};

      if (spaceBottom >= popupHeight) {
        newPosition = "bottom";
        styles = {
          top: `${wrapperRect.bottom}px`,
          left: `${wrapperRect.left + wrapperRect.width / 2 - popupWidth / 2}px`,
        };
      } else if (spaceTop >= popupHeight) {
        newPosition = "top";
        styles = {
          top: `${wrapperRect.top - popupHeight}px`,
          left: `${wrapperRect.left + wrapperRect.width / 2 - popupWidth / 2}px`,
        };
      } else if (spaceRight >= popupWidth) {
        newPosition = "right";
        styles = {
          top: `${wrapperRect.top + wrapperRect.height / 2 - popupHeight / 2}px`,
          left: `${wrapperRect.right}px`,
        };
      } else if (spaceLeft >= popupWidth) {
        newPosition = "left";
        styles = {
          top: `${wrapperRect.top + wrapperRect.height / 2 - popupHeight / 2}px`,
          left: `${wrapperRect.left - popupWidth}px`,
        };
      } else {
        newPosition = "bottom";
        styles = {
          top: `${wrapperRect.bottom}px`,
          left: `${wrapperRect.left + wrapperRect.width / 2 - popupWidth / 2}px`,
        };
      }

      setPosition(newPosition);
      setPopupStyle(styles);
    }
  }, [isHovering]);

  return (
    <div
      ref={wrapperRef}
      className="popup-wrapper"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => {
        setTimeout(() => {
          setIsHovering(false);
        }, 150);
      }}
    >
      <div className="popup-trigger">{trigger}</div>

      {isHovering && (
        <div
          ref={popupRef}
          style={popupStyle}
          className={`popup-box popup-box--${position} ${flowing ? "popup-box--flowing" : ""} ${hoverable ? "popup-box--hoverable" : ""}`}
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => {
            setTimeout(() => {
              setIsHovering(false);
            }, 150);
          }}
        >
          {content}
        </div>
      )}
    </div>
  );
};

Popup.propTypes = {
  trigger: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  flowing: PropTypes.bool,
  hoverable: PropTypes.bool,
};

export default Popup;
